"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return ArrowGroup;
    }
});
const _konva = /*#__PURE__*/ _interop_require_default(require("konva"));
const _Group = require("../Group");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
class ArrowGroup extends _Group.ShapeGroup {
    _childAttributes() {
        // Optionally register subclass attributes here.
        this.flatPoints = [];
    }
    _unpack(shape = {}, config = {}) {
        const { points = [] } = shape;
        this.flatPoints = [
            points[0].x,
            points[0].y,
            points[1].x,
            points[1].y
        ];
    }
    _init(shape = {}, config = {}) {
        this.node = new _konva.default.Arrow({
            points: this.flatPoints,
            stroke: "black",
            fill: "black",
            strokeWidth: 8,
            tension: 1,
            draggable: this.draggable,
            hitStrokeWidth: 10
        });
    }
    _update(shape = {}, config = {}) {
        this.node.setAttrs({
            points: this.flatPoints
        });
    }
    _stroke() {
        const tension = 1;
        // Create the arrow fill
        const arrowFill = new _konva.default.Arrow({
            name: "arrow-fill",
            points: this.flatPoints,
            stroke: "white",
            fill: "white",
            tension: tension,
            listening: false
        });
        return arrowFill;
    }
}
